 //登录
 import Router from 'vue-router'
 import axios from 'axios';
 import {
   getEnv
 } from '../utils/env.js'

//  import {
//    getUrlKey
//  } from '../utils/methods.js'

 var env = getEnv();
 var devtoken = '281a10a70c6768fec8649705c8d2d060' //生产环境token
 let entCode = process.env.NODE_ENV&&process.env.NODE_ENV=='development'?'heinz':'Heinz'
 export const login = ({
   userName,
   password,
   authCode
 }) => {
   const data = {
     userName,
     password,
     authCode,
     type:3,
     isManageSystem:1//是否管理端
   }
   return axios.request({
    //  url: `${env}/data-base-v2/open/${getUrlKey('entCode')}/login`,
    //  url: `${env}/data-base/open/${getUrlKey('entCode')}/login`, 
    url: `${env}/data-base/open/${entCode}/login`,
     data,
     method: 'post'
   })
 }
 export const getmenus = ({
   userId
 }) => {
   const data = {
     userId
   }
   
   return axios.request({
     url: `${env}/data-base/api/auth/menu/list`,
     data,
     headers: {
       'token': localStorage.getItem(devtoken)
     },
     method: 'post'
   })
 }
 export const loginOut = () => {
  const data = {}
  return axios.request({
    url: `${env}/data-base/open/touyun/logout`,
    data,
    headers: {
      'token': localStorage.getItem(devtoken)
    },
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js